import { create } from 'zustand';
// ---------------------------------------------------------------------------
// Store
// ---------------------------------------------------------------------------
export const useCartUi = create()((set, get) => ({
    pendingFlyTo: [],
    bumpKey: 0,
    anchorStack: [],
    triggerFlyTo: (fromRect, imageUrl) => set((s) => ({
        pendingFlyTo: [
            ...s.pendingFlyTo,
            { fromRect, imageUrl, key: crypto.randomUUID() },
        ],
    })),
    removeFlyTo: (key) => set((s) => ({ pendingFlyTo: s.pendingFlyTo.filter((f) => f.key !== key) })),
    registerAnchor: (el) => {
        set((s) => ({ anchorStack: [...s.anchorStack, el] }));
        return () => set((s) => ({ anchorStack: s.anchorStack.filter((e) => e !== el) }));
    },
    getAnchorRect: () => get().anchorStack.at(-1)?.getBoundingClientRect() ?? null,
    notifyLanded: () => set((s) => ({ bumpKey: s.bumpKey + 1 })),
}));
